if (!customElements.get("build-your-capsule")) {
  customElements.define(
    "build-your-capsule",
    class BuildYourCapsule extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.selections = [];
        this.activeSlotIndex = 0;
        this.initialized = false;
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.modal = document.getElementById(this.dataset.capsuleModalId);
        this.modalTitle =
          this.modal?.querySelector("[data-capsule-modal-title]") || null;
        this.panels = this.modal
          ? [...this.modal.querySelectorAll("[data-capsule-panel]")]
          : [];
        this.selections = new Array(this.panels.length).fill(null);

        const pricingConfigEl = this.querySelector(
          "[data-capsule-pricing-config]",
        );
        if (pricingConfigEl) {
          try {
            this.pricingConfig = JSON.parse(pricingConfigEl.textContent);
          } catch (error) {
            console.error(error);
          }
        }

        this.bundlePriceEl = this.querySelector("[data-capsule-bundle-price]");
        this.regularPriceEl = this.querySelector("[data-capsule-regular-price]");
        this.saveEl = this.querySelector("[data-capsule-save]");
        this.addButton = this.querySelector("[data-capsule-add-button]");
        this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");

        this.updatePricing();

        this.addEventListener("click", this.onClick);
        this.modal?.addEventListener("click", this.onClick);
        document.addEventListener("click", this.onDocumentClick);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onClick);
        this.modal?.removeEventListener("click", this.onClick);
        document.removeEventListener("click", this.onDocumentClick);
      }

      onClick(event) {
        const slotProduct = event.target.closest("[data-capsule-slot-product]");
        if (slotProduct && this.contains(slotProduct)) {
          if (event.target.closest("[data-capsule-slot-trigger]")) {
            event.preventDefault();
            event.stopPropagation();
            this.openModal(Number(slotProduct.dataset.capsuleSlotIndex));
            return;
          }

          const sizeTrigger = event.target.closest(
            "[data-capsule-size-trigger]",
          );
          if (sizeTrigger) {
            event.preventDefault();
            event.stopPropagation();
            this.toggleSizeDropdown(sizeTrigger);
            return;
          }

          const sizeOption = event.target.closest(
            "[data-capsule-size-option]",
          );
          if (sizeOption) {
            event.preventDefault();
            event.stopPropagation();
            this.applySizeOption(sizeOption);
            return;
          }

          const swatch = event.target.closest("[data-capsule-swatch]");
          if (swatch) {
            event.preventDefault();
            event.stopPropagation();
            this.applySwatch(swatch);
            return;
          }

          return;
        }

        const slotTrigger = event.target.closest("[data-capsule-slot-trigger]");
        if (slotTrigger && this.contains(slotTrigger)) {
          event.preventDefault();
          this.openModal(Number(slotTrigger.dataset.capsuleSlotTrigger));
          return;
        }

        if (event.target.closest("[data-capsule-add-button]")) {
          event.preventDefault();
          this.addCapsuleToCart();
          return;
        }

        if (!this.modal?.contains(event.target)) return;

        const productToggle = event.target.closest(
          "[data-capsule-product-toggle]",
        );
        if (productToggle) {
          event.preventDefault();
          event.stopPropagation();
          this.selectProduct(productToggle.closest("[data-capsule-product]"));
          return;
        }

        const productCard = event.target.closest("[data-capsule-product]");
        if (
          productCard &&
          !event.target.closest(
            "[data-capsule-size-trigger], [data-capsule-size-option], [data-capsule-swatch]",
          )
        ) {
          this.selectProduct(productCard);
          return;
        }

        const sizeTrigger = event.target.closest("[data-capsule-size-trigger]");
        if (sizeTrigger) {
          event.preventDefault();
          event.stopPropagation();
          this.toggleSizeDropdown(sizeTrigger);
          return;
        }

        const sizeOption = event.target.closest("[data-capsule-size-option]");
        if (sizeOption) {
          event.preventDefault();
          event.stopPropagation();
          this.applySizeOption(sizeOption);
          return;
        }

        const swatch = event.target.closest("[data-capsule-swatch]");
        if (swatch) {
          event.preventDefault();
          event.stopPropagation();
          this.applySwatch(swatch);
          return;
        }

        if (event.target.closest("[data-capsule-confirm]")) {
          event.preventDefault();
          this.confirmSelection();
        }
      }

      onDocumentClick(event) {
        this.getDropdownRoots().forEach((root) => {
          root
            .querySelectorAll("[data-capsule-size-dropdown]")
            .forEach((dropdown) => {
              const trigger = dropdown.parentElement?.querySelector(
                "[data-capsule-size-trigger]",
              );
              if (
                !trigger ||
                trigger.contains(event.target) ||
                dropdown.contains(event.target)
              )
                return;
              dropdown.hidden = true;
              trigger.setAttribute("aria-expanded", "false");
            });
        });
      }

      getDropdownRoots() {
        return [this, this.modal].filter(Boolean);
      }

      openModal(slotIndex) {
        if (!this.modal) return;

        this.activeSlotIndex = slotIndex;
        this.updateModalPanel(slotIndex);

        const trigger = this.querySelector(
          `[data-capsule-slot-trigger="${slotIndex}"]`,
        );
        this.modal.show(trigger || this);
      }

      updateModalPanel(slotIndex) {
        this.panels.forEach((panel, index) => {
          panel.hidden = index !== slotIndex;
        });

        const panel = this.panels[slotIndex];
        if (!panel) return;

        const title = panel.dataset.capsulePanelTitle || "";
        if (this.modalTitle) this.modalTitle.textContent = title;

        const confirmButton = this.getConfirmButton();
        if (confirmButton && panel.dataset.capsulePanelSelect) {
          confirmButton.textContent = panel.dataset.capsulePanelSelect;
        }

        const stepEl = this.modal?.querySelector(".capsule-modal__step");
        if (stepEl) {
          stepEl.textContent =
            ["1", "2", "3"][slotIndex] || String(slotIndex + 1);
        }

        panel
          .querySelectorAll("[data-capsule-product]")
          .forEach((productEl) => {
            productEl.classList.remove("is-selected");
            const toggle = productEl.querySelector(
              "[data-capsule-product-toggle]",
            );
            if (toggle) toggle.setAttribute("aria-pressed", "false");
          });

        const existingSelection = this.selections[slotIndex];
        if (existingSelection) {
          let selectedProduct = panel.querySelector(
            `[data-capsule-product][data-product-id="${existingSelection.productId}"]`,
          );

          if (!selectedProduct) {
            selectedProduct = [
              ...panel.querySelectorAll("[data-capsule-product]"),
            ].find((productEl) =>
              [...productEl.querySelectorAll("[data-capsule-swatch]")].some(
                (swatch) =>
                  swatch.dataset.productId ===
                  String(existingSelection.productId),
              ),
            );
          }

          if (selectedProduct) {
            if (
              selectedProduct.dataset.productId !==
              String(existingSelection.productId)
            ) {
              const swatch = selectedProduct.querySelector(
                `[data-capsule-swatch][data-product-id="${existingSelection.productId}"]`,
              );
              if (swatch) this.applySwatch(swatch);
            } else {
              this.applySelectionDataToProduct(
                selectedProduct,
                existingSelection,
              );
            }

            const sizeOption = selectedProduct.querySelector(
              `[data-capsule-size-option][data-variant-id="${existingSelection.variantId}"]`,
            );
            if (sizeOption) this.applySizeOption(sizeOption);

            this.selectProduct(selectedProduct, false);
          }
        }

        this.updateConfirmButton(panel);
      }

      selectProduct(productEl, focusToggle = true) {
        const panel = productEl.closest("[data-capsule-panel]");
        if (!panel) return;

        panel.querySelectorAll("[data-capsule-product]").forEach((item) => {
          item.classList.remove("is-selected");
          const toggle = item.querySelector("[data-capsule-product-toggle]");
          if (toggle) toggle.setAttribute("aria-pressed", "false");
        });

        productEl.classList.add("is-selected");
        const toggle = productEl.querySelector("[data-capsule-product-toggle]");
        if (toggle) {
          toggle.setAttribute("aria-pressed", "true");
          if (focusToggle) toggle.focus();
        }

        this.updateConfirmButton(panel);
      }

      toggleSizeDropdown(trigger) {
        const dropdown = trigger.parentElement?.querySelector(
          "[data-capsule-size-dropdown]",
        );
        if (!dropdown) return;

        const willOpen = dropdown.hidden;
        this.closeAllSizeDropdowns();
        dropdown.hidden = !willOpen;
        trigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
      }

      closeAllSizeDropdowns() {
        this.getDropdownRoots().forEach((root) => {
          root
            .querySelectorAll("[data-capsule-size-dropdown]")
            .forEach((dropdown) => {
              dropdown.hidden = true;
            });
          root
            .querySelectorAll("[data-capsule-size-trigger]")
            .forEach((trigger) => {
              trigger.setAttribute("aria-expanded", "false");
            });
        });
      }

      applySizeOption(option) {
        const productEl = option.closest("[data-capsule-product]");
        if (!productEl) return;

        const variantId = option.dataset.variantId;
        const variantTitle = option.dataset.variantTitle;
        const imageSrc = option.dataset.imageSrc;
        const variantPrice = Number(option.dataset.variantPrice || 0);

        productEl.dataset.variantId = variantId;
        productEl.dataset.variantTitle = variantTitle;
        productEl.dataset.variantPrice = String(variantPrice);
        if (imageSrc) productEl.dataset.imageSrc = imageSrc;

        const label = productEl.querySelector("[data-capsule-size-label]");
        if (label) label.textContent = variantTitle;

        const image = productEl.querySelector("[data-capsule-product-image]");
        if (image && imageSrc) image.src = imageSrc;

        productEl
          .querySelectorAll("[data-capsule-size-option]")
          .forEach((item) => {
            item.classList.toggle("is-selected", item === option);
          });

        this.closeAllSizeDropdowns();

        const slotIndex = productEl.dataset.capsuleSlotIndex;
        if (slotIndex !== undefined) {
          this.syncSelectionFromProduct(productEl, Number(slotIndex));
          return;
        }

        this.selectProduct(productEl, false);
      }

      applySwatch(swatch) {
        const productEl = swatch.closest("[data-capsule-product]");
        if (!productEl) return;

        const jsonEl = productEl.querySelector("[data-capsule-product-json]");
        if (!jsonEl) return;

        let productData;
        try {
          productData = JSON.parse(jsonEl.textContent);
        } catch (error) {
          console.error(error);
          return;
        }

        const sibling = (productData.siblings || []).find(
          (item) => String(item.id) === swatch.dataset.productId,
        );
        if (!sibling) return;

        const selectedVariant =
          sibling.variants.find((variant) => variant.available) ||
          sibling.variants[0];
        if (!selectedVariant) return;

        productEl.dataset.productId = String(sibling.id);
        productEl.dataset.productTitle = sibling.title;
        productEl.dataset.variantId = String(selectedVariant.id);
        productEl.dataset.variantTitle = selectedVariant.title;
        productEl.dataset.variantPrice = String(selectedVariant.price || 0);
        productEl.dataset.imageSrc =
          selectedVariant.image || sibling.image || "";

        const title = productEl.querySelector("[data-capsule-product-title]");
        if (title) title.textContent = sibling.title;

        const label = productEl.querySelector("[data-capsule-size-label]");
        if (label) label.textContent = selectedVariant.title;

        const image = productEl.querySelector("[data-capsule-product-image]");
        if (image && (selectedVariant.image || sibling.image)) {
          image.src = selectedVariant.image || sibling.image;
          image.alt = sibling.title;
        }

        this.rebuildSizeDropdown(
          productEl,
          sibling.variants,
          selectedVariant.id,
        );

        const swatches = productEl.querySelector("[data-capsule-swatches]");
        if (swatches) {
          swatches
            .querySelectorAll(".capsule-modal-product__swatch-wrap")
            .forEach((item) => {
              item.classList.toggle(
                "is-selected",
                item.querySelector("[data-capsule-swatch]")?.dataset
                  .productId === String(sibling.id),
              );
            });
        }

        const slotIndex = productEl.dataset.capsuleSlotIndex;
        if (slotIndex !== undefined) {
          this.syncSelectionFromProduct(productEl, Number(slotIndex));
          return;
        }

        this.selectProduct(productEl, false);
      }

      rebuildSizeDropdown(productEl, variants, selectedVariantId) {
        const dropdown = productEl.querySelector(
          "[data-capsule-size-dropdown]",
        );
        if (!dropdown || !variants?.length) return;

        dropdown.innerHTML = variants
          .map((variant) => {
            const selectedClass =
              String(variant.id) === String(selectedVariantId)
                ? " is-selected"
                : "";
            const unavailableClass = variant.available ? "" : " is-unavailable";
            const disabled = variant.available ? "" : " disabled";
            return `
              <button
                type="button"
                class="capsule-modal-product__size-option${selectedClass}${unavailableClass}"
                data-capsule-size-option
                data-variant-id="${variant.id}"
                data-variant-title="${this.escapeHtml(variant.title)}"
                data-variant-available="${variant.available}"
                data-variant-price="${variant.price}"
                data-image-src="${this.escapeHtml(variant.image || "")}"
                ${disabled}
              >
                ${this.escapeHtml(variant.title)}
              </button>
            `;
          })
          .join("");
      }

      applySelectionDataToProduct(productEl, selection) {
        productEl.dataset.productId = selection.productId;
        productEl.dataset.productTitle = selection.title;
        productEl.dataset.variantId = selection.variantId;
        productEl.dataset.variantTitle = selection.variantTitle;
        if (selection.image) productEl.dataset.imageSrc = selection.image;

        const title = productEl.querySelector("[data-capsule-product-title]");
        if (title) title.textContent = selection.title;

        const label = productEl.querySelector("[data-capsule-size-label]");
        if (label) label.textContent = selection.variantTitle;

        const image = productEl.querySelector("[data-capsule-product-image]");
        if (image && selection.image) {
          image.src = selection.image;
          image.alt = selection.title;
        }

        const swatches = productEl.querySelector("[data-capsule-swatches]");
        if (swatches) {
          swatches
            .querySelectorAll(".capsule-modal-product__swatch-wrap")
            .forEach((item) => {
              item.classList.toggle(
                "is-selected",
                item.querySelector("[data-capsule-swatch]")?.dataset
                  .productId === String(selection.productId),
              );
            });
        }
      }

      getActivePanel() {
        return this.panels[this.activeSlotIndex] || null;
      }

      getSelectedProduct(panel) {
        return panel.querySelector("[data-capsule-product].is-selected");
      }

      getConfirmButton() {
        return this.modal?.querySelector("[data-capsule-confirm]") || null;
      }

      updateConfirmButton(panel) {
        const confirmButton = this.getConfirmButton(panel);
        if (!confirmButton) return;
        const hasSelection = Boolean(this.getSelectedProduct(panel));
        confirmButton.disabled = !hasSelection;
        confirmButton.setAttribute(
          "aria-disabled",
          hasSelection ? "false" : "true",
        );
      }

      confirmSelection() {
        const panel = this.panels[this.activeSlotIndex];
        const selectedProduct = panel ? this.getSelectedProduct(panel) : null;
        if (!selectedProduct) return;

        const slotProduct = selectedProduct.cloneNode(true);
        slotProduct.classList.add("capsule-modal-product--slot");
        slotProduct.dataset.capsuleSlotProduct = "";
        slotProduct.dataset.capsuleSlotIndex = String(this.activeSlotIndex);
        slotProduct.classList.remove("is-selected");
        slotProduct.querySelector("[data-capsule-product-toggle]")?.remove();

        const unique = `slot-${this.activeSlotIndex}-${Date.now()}`;
        const sizeTrigger = slotProduct.querySelector(
          "[data-capsule-size-trigger]",
        );
        const sizeDropdown = slotProduct.querySelector(
          "[data-capsule-size-dropdown]",
        );
        if (sizeTrigger) sizeTrigger.dataset.capsuleSizeTrigger = unique;
        if (sizeDropdown) sizeDropdown.dataset.capsuleSizeDropdown = unique;

        const imageWrap = slotProduct.querySelector(
          ".capsule-modal-product__image",
        );
        if (imageWrap) {
          imageWrap.dataset.capsuleSlotTrigger = this.activeSlotIndex;
          imageWrap.setAttribute("role", "button");
          imageWrap.setAttribute(
            "aria-label",
            slotProduct.dataset.productTitle || "",
          );
        }

        this.renderSlotProduct(this.activeSlotIndex, slotProduct);
        this.syncSelectionFromProduct(
          slotProduct,
          this.activeSlotIndex,
        );
        this.modal?.hide();
      }

      renderSlotProduct(slotIndex, productEl) {
        const slot = this.querySelector(`[data-capsule-slot="${slotIndex}"]`);
        if (!slot) return;

        const emptyLabel = slot.dataset.emptyLabel || "";
        slot.innerHTML = "";
        slot.appendChild(productEl);
        slot.dataset.emptyLabel = emptyLabel;
        slot.classList.add("is-filled");
      }

      syncSelectionFromProduct(productEl, slotIndex) {
        const price = this.getProductVariantPrice(
          productEl,
          productEl.dataset.variantId,
        );

        this.selections[slotIndex] = {
          productId: productEl.dataset.productId,
          title: productEl.dataset.productTitle,
          variantId: productEl.dataset.variantId,
          variantTitle: productEl.dataset.variantTitle,
          image: productEl.dataset.imageSrc,
          price,
        };

        this.updatePricing();
      }

      getProductVariantPrice(productEl, variantId) {
        const jsonEl = productEl.querySelector("[data-capsule-product-json]");
        if (!jsonEl) return Number(productEl.dataset.variantPrice || 0);

        try {
          const data = JSON.parse(jsonEl.textContent);
          const variant = (data.variants || []).find(
            (item) => String(item.id) === String(variantId),
          );
          if (variant) return Number(variant.price || 0);

          for (const sibling of data.siblings || []) {
            const siblingVariant = (sibling.variants || []).find(
              (item) => String(item.id) === String(variantId),
            );
            if (siblingVariant) return Number(siblingVariant.price || 0);
          }
        } catch (error) {
          console.error(error);
        }

        return Number(productEl.dataset.variantPrice || 0);
      }

      formatAmount(cents) {
        const amount = cents / 100;
        const locale = this.pricingConfig?.locale || this.dataset.locale || "en";

        if (locale === "de") {
          return new Intl.NumberFormat("de-DE", {
            maximumFractionDigits: 0,
          }).format(amount);
        }

        if (locale === "nb") {
          return new Intl.NumberFormat("nb-NO", {
            maximumFractionDigits: 0,
          })
            .format(amount)
            .replace(/\u00a0/g, " ");
        }

        return new Intl.NumberFormat("da-DK", {
          maximumFractionDigits: 0,
        }).format(amount);
      }

      formatPricingLine(template, cents) {
        if (!template) return "";
        return template.replace(
          /\{\{\s*amount\s*\}\}/g,
          this.formatAmount(cents),
        );
      }

      updatePricing() {
        if (!this.pricingConfig) return;

        const regularTotal = this.selections.reduce(
          (sum, selection) => sum + (selection?.price || 0),
          0,
        );
        const saveAmount = Math.max(
          0,
          regularTotal - Number(this.pricingConfig.bundlePriceCents || 0),
        );
        const hasSelections = this.selections.some(Boolean);

        if (this.bundlePriceEl) {
          this.bundlePriceEl.textContent = this.pricingConfig.bundleLine;
        }

        if (this.regularPriceEl) {
          this.regularPriceEl.textContent = this.formatPricingLine(
            this.pricingConfig.regularLine,
            regularTotal,
          );
        }

        if (this.saveEl) {
          const saveText = this.formatPricingLine(
            this.pricingConfig.saveLine,
            saveAmount,
          );
          const savePercent =
            regularTotal > 0
              ? Math.round((saveAmount / regularTotal) * 100)
              : 0;
          this.saveEl.textContent =
            savePercent > 0 ? `${saveText} (${savePercent}%)` : saveText;
          this.saveEl.hidden = !hasSelections || saveAmount <= 0;
        }

        this.updateAddButtonState();
      }

      isAllSlotsFilled() {
        return (
          this.selections.length > 0 &&
          this.selections.every((selection) => Boolean(selection?.variantId))
        );
      }

      updateAddButtonState() {
        if (!this.addButton) return;

        const allFilled = this.isAllSlotsFilled();
        this.addButton.disabled = !allFilled;
        this.addButton.setAttribute(
          "aria-disabled",
          allFilled ? "false" : "true",
        );
      }

      setAddButtonLoading(isLoading) {
        if (!this.addButton) return;

        const spinner = this.addButton.querySelector(".loading__spinner");
        this.addButton.classList.toggle("loading", isLoading);
        this.addButton.disabled = isLoading || !this.isAllSlotsFilled();
        this.addButton.setAttribute(
          "aria-disabled",
          isLoading || !this.isAllSlotsFilled() ? "true" : "false",
        );
        if (spinner) spinner.classList.toggle("hidden", !isLoading);
      }

      async addCapsuleToCart() {
        if (!this.isAllSlotsFilled()) return;

        const items = this.selections.map((selection) => ({
          id: Number(selection.variantId),
          quantity: 1,
          properties: {
            _capsule: "true",
          },
        }));

        this.setAddButtonLoading(true);

        try {
          const cart =
            document.querySelector("cart-drawer") ||
            document.querySelector("cart-notification");

          if (!cart) {
            const addResponse = await fetch(`${routes.cart_add_url}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ items }),
            });
            const addResult = await addResponse.json();

            if (!addResponse.ok || addResult.status) {
              throw new Error(
                addResult.description || addResult.message || "Add to cart failed",
              );
            }

            window.location = window.routes.cart_url;
            return;
          }

          if (typeof cart.setActiveElement === "function" && this.addButton) {
            cart.setActiveElement(this.addButton);
          }

          const sectionIds = cart
            .getSectionsToRender()
            .map((section) => section.id);

          const addResponse = await fetch(`${routes.cart_add_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              items,
              sections: sectionIds.join(","),
              sections_url: window.location.pathname,
            }),
          });
          const addResult = await addResponse.json();

          if (!addResponse.ok || addResult.status) {
            throw new Error(
              addResult.description || addResult.message || "Add to cart failed",
            );
          }

          cart.renderContents(addResult);

          if (cart.classList.contains("is-empty")) {
            cart.classList.remove("is-empty");
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.setAddButtonLoading(false);
        }
      }

      escapeHtml(value) {
        return String(value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }
    },
  );
}
